const generatorTokens = {
  generatorTokens: {
    generator_tokens: '発電機トークン',
    purchase_dt: '購入日',
    purchased_from: '購入先',
    status: 'ステータス',
    site_id: 'サイト ID',
    manufacturer_name: 'メーカー名',
    model_info: 'モデル情報',
    activation_dt: 'アクティベーション日',
    footer: '発電機トークン',
    total: '合計',
    records: '記録',
    token: 'トークン',
    tokens: 'トークン',
    show: '表示',
    to: '～',
    of: '/',
    noTokens: '** 利用可能な発電機トークンはありません **',
    heading: '発電機トークン',
    assignToSubContractor: '下請業者に割り当てる',
    cancel: 'キャンセル',
    next: '次へ',
    back: '戻る',
    assign: '割り当てる',
    distributorConfirmation: '私は、本設置業者が以下の情報を伝達されたことを確認します：',
    masterDistributorConfirmation: '私は、本販売業者が以下の情報を伝達されたことを確認します：',
    distributorGeneratorTokens: '発電機トークンは、以下の発電機の設置にのみ使用できます',
    enphaseSupportedGenerator: ' Enphase対応発電機リスト',
    assignToSubcontractorButton: '認定下請業者に割り当てる',
    noSiteIdTooltip: 'Installer Toolkitアプリケーションから割り当てを完了してください。',
    purchaseDateTooltip: 'このトークンがEnphase Storeから購入された日時を示します。',
    unassignmentMsg: 'ご連絡ください ',
    newTokenMessage: '新しく購入されたトークンは、この表に反映されるまでに最大60分かかる場合があります。60分経っても反映されない場合は、ご連絡ください ',
    tokenReassignMessage: '他の設置業者から割り当てられたトークンを再度割り当てることはできません',
    unassignmentOfTokensMsg: 'すでに割り当てられているトークンの割り当てを解除したい場合',
    selectCompany: '会社を選択',
    subcontractor_company: '下請業者',
    purchaseNewToken: '新しいトークンを購入',
    unassigOfInstallerTokensMsg: 'すでに下請業者に割り当てられているトークンの割り当てを解除したい場合',
    redirectToStoreText: 'Enphase Storeにリダイレクトしています。お待ちください...',
    /*distributor*/
    assigned_to: '割当先',
    action: 'アクション',
    bulkAssign: '一括割り当て',
    addEmailId: '電子メールIDを追加する',
    addEmailIdMessage: 'このトークンへのアクセスを別の会社に提供するには、その会社のEnphaseユーザーのメールアドレスを入力します。',
    search: '検索',
    assignToInstaller: '設置業者に割り当てる',
    assignToDistributor: '販売業者に割り当てる',
    enphaseEnergy: 'Enphase Energy',
    ok: 'Ok',
    okay: 'Ok',
    modalTextLarge: 'ご注文は正常に完了しました。',
    modalTextSmall: '支払いは処理中であり、最新のステータスに更新されるまで時間がかかる場合があります。',
    paymentStatus: '支払状況',
    noSubcontractorMessage: '貴社に追加された認定下請業者はありません。認定下請業者を追加するには、お客様の会社の管理者にご連絡ください。'
  }
};

export default generatorTokens;
